import axiosInstance from "./axiosConfig";

export const gymMembersAPI = {
  // Create a new gym member
  createMember: (data) => axiosInstance.post("/api/gymmembers/create/", data),

  // Get all members with optional filters
  getMembers: (params = {}) =>
    axiosInstance.get("/api/gymmembers/", { params }),

  // Get member by ID
  getMemberById: (id) => axiosInstance.get(`/api/gymmembers/${id}/`),

  // Update member
  updateMember: (id, data) =>
    axiosInstance.put(`/api/gymmembers/${id}/update/`, data),

  // Delete member
  deleteMember: (id) => axiosInstance.delete(`/api/gymmembers/${id}/delete/`),

  // Get member report with filters
  getMemberReport: (params = {}) =>
    axiosInstance.get("/api/gymmembers/report/", { params }),

  // Search members
  searchMembers: (query) =>
    axiosInstance.get("/api/gymmembers/search/", {
      params: { q: query },
    }),

  // Get member statistics
  getMemberStats: () => axiosInstance.get("/api/gymmembers/stats/"),

  // Export members data
  exportMembers: (format = "csv") =>
    axiosInstance.get(`/api/gymmembers/export/?format=${format}`, {
      responseType: "blob",
    }),
};
